<template>
    <v-container>
      <v-layout row>
        <v-flex xs12>
        <v-card class="layout elevation-11">
          <v-card-text >
            <div class="top">
              <h4 v-if="loadedSonglist">{{loadedSonglist.name}}</h4 > 
              <h4 v-else>{{user.name}}'s songlist</h4 > 
              <v-btn v-if="isAdmin && !editing" class="secondary ml-4 mr-3 add" small @click="editing=true">Edit name</v-btn>
              <v-btn v-if="isAdmin && editing" class="secondary ml-4 mr-3 add" small @click="saveName">Save name</v-btn>
              <v-btn v-if="isAdmin" class="primary mr-3 add" small @click="addSongs">Add song</v-btn>
              <v-btn v-if="isAdmin" small class="add" @click="$router.push('songlists')">Cancel</v-btn>
            </div>
            <div v-if="isAdmin && editing">
              <v-layout row wrap>
                 <v-flex xs8 sm4>
                  <v-text-field 
                    solo
                    label="Enter new name" 
                    id="name" type="text" 
                    class="mt-3 mb-0"
                    autofocus 
                    v-model.trim="name">
                  </v-text-field>
                 </v-flex>
              </v-layout>
            </div>
          <hr class="mb-4 mt-3">
          <span v-if="loadedSonglist">
            <div v-for="(song, index) in songs" :key="index" class="songs">
              <p v-if="isAdmin" class="item">
                <i class="material-icons icon"
                  @click="deleteSong({title: song.title, idx: song.idx, songId: song.songId})">delete_outline
                </i>
                <span class="edit" @click="edit(song)">{{song.title}} - {{song.artist}} {{ getNotes( song.notes) }}</span>
              </p>
              <p v-else class="item">{{song.title}} - {{song.artist}} -- {{song.notes}} </p>
            </div>
          </span>
          <span v-else>
           <p> You currently have no songs in your song list.</p>
          </span>
          <v-layout row class="btm" > 
            <v-flex xs12>
              <v-btn v-if="isAdmin" small class="mt-4 add" @click="$router.push('songlists')">Cancel</v-btn>
            </v-flex>
          </v-layout>
          </v-card-text>
        </v-card>
        </v-flex>
      </v-layout>
    </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { generateUUID, alphabetize } from '../../mixins/utilities.js'
export default {
  mounted() {
    window.scrollTo(0, 0);
    this.isAdmin ?  this.loadedSonglist = this.$store.getters.getLoadedSonglist : this.loadedSonglist = this.$store.getters.getLoadedSonglist[0]
  },
  data() {
    return {
      loadedSonglist: [],
      user: this.$store.getters.getUser,
      editing: false,
      name: ""
    }
  },
  computed: {
    isAdmin() {
      return this.user.userId === this.$store.state.adminId
    },
    songs() {
      let arrTitles = []
      let objSong = {}
      let arrSongs = this.loadedSonglist.songs

      for (let i = 0; i < arrSongs.length; i++) {
        objSong = {
            title: arrSongs[i].title,
            artist: arrSongs[i].artist,
            notes: arrSongs[i].notes,
            songId: arrSongs[i].songId,
            idx: i
          }
        arrTitles.push(objSong)
      }

      let arrAlphabetized = arrTitles.sort((a, b) => {
        return (a.title< b.title) ? -1 : (a.title > b.title) ? 1 : 0
      })
      return arrAlphabetized
    }
  },
  methods: {
    saveName() {
      this.$store.commit('updateSonglistName', this.name)
      this.saveSonglist()
    },
    deleteSong(objSong) {
      let str = `Remove "${objSong.title}" from ${this.loadedSonglist.name}?`
      if (confirm(str)) {
        this.$store.commit('deleteFromSonglist', objSong.idx)
        this.saveSonglist()
      }
    },
    getNotes(note) {
      let strNotes
      if (!note) {
        strNotes = ''
      } else {
        strNotes =  `-- ${note}`
      }
      return strNotes
    },
    edit(objSong) {
      this.$router.push({
        name: 'editSong',
        params: { song: objSong }
      })
    },
    addSongs() {
      this.$router.push('addSong')
    },
    saveSonglist() {
      this.$store.dispatch('editSonglist')
      this.editing = false
    }
  }
}
</script>

<style scoped>
.container {
  padding: 0px;
}
.layout {
  margin-top: 0px;
  margin-left: auto;
  margin-right: auto;
}

.top {
  display: flex;
  align-items: baseline;
  /* justify-content: space-between; */
}

.btm {
  display: flex;
  flex-direction: column;
}

.add {
  font-size: 0.8rem;
  padding: 0;
}

.songs {
  margin-left: 0px;
}

h4 {
  font-size: 1.2rem;
}

.icon {
  cursor: pointer;
  margin-right: 6px;
  margin-left: 0;
}

a {
  color: #597884;
}

.lyrics {
  cursor: pointer;
  text-decoration: underline;
}

.item {
  display: inline-flex;
  align-items: center;
  font-size: .9rem;
  margin-bottom: 10px;
}
.edit {
  text-decoration: underline;
  cursor: pointer;
}

.editing {
  display: inline-flex;
  align-items: baseline;
}
</style>